import { CreatedByType } from 'types/common';
import { IDeletedStatusOption } from './types';

// export const createdByOptions: CreatedByType[] = ['all', 'admin', 'parser', 'user'];
// export const createdByOptions: CreatedByType[] = ['all', 'withOwner', 'withoutOwner'];
export const deletedStatusOptions: IDeletedStatusOption[] = [
  { id: 'true', name: 'deleted' },
  { id: 'false', name: 'notDeleted' },
];

export const NAME = 'isDeleted';

export const DEFAULT_CREATED_BY: CreatedByType = 'all';
